import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { type MouseEvent, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';

const FORWARDED_PARAM = 'forwarded';

const hasForwardedFlag = (params: URLSearchParams) => params.getAll(FORWARDED_PARAM).includes('true');

export const ForwardedUrlNotice = () => {
    const intl = useIntl();
    const [routeSearchParams, setRouteSearchParams] = useSearchParams();
    const [show, setShow] = useState(
        () => hasForwardedFlag(routeSearchParams) || hasForwardedFlag(new URLSearchParams(window.location.search))
    );

    const dismiss = () => {
        setShow(false);

        const browserSearchParams = new URLSearchParams(window.location.search);
        if (browserSearchParams.has(FORWARDED_PARAM)) {
            browserSearchParams.delete(FORWARDED_PARAM);
            const nextSearch = browserSearchParams.toString();
            const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
            window.history.replaceState(window.history.state, '', nextUrl);
        }

        if (routeSearchParams.has(FORWARDED_PARAM)) {
            const nextRouteSearchParams = new URLSearchParams(routeSearchParams);
            nextRouteSearchParams.delete(FORWARDED_PARAM);
            setRouteSearchParams(nextRouteSearchParams, { replace: true });
        }
    };

    // UIKIT 2.4 does not close Dialog when its backdrop is clicked. Dialog forwards DOM events to its root.
    const backdropClick = {
        onClick: (event: MouseEvent<HTMLDivElement>) => {
            const content = event.currentTarget.querySelector('[role="document"]');
            if (!content?.contains(event.target as Node)) {
                dismiss();
            }
        },
    };

    return (
        <Dialog
            {...backdropClick}
            show={show}
            onClose={dismiss}
            title={intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.forwarded-url.title' })}
            body={<FormattedMessage id='intl-msg:ordercom-cloud-frontend.forwarded-url.body' />}
            footer={
                <Button bsStyle={Button.PRIMARY} onClick={dismiss}>
                    <FormattedMessage id='intl-msg:ordercom-cloud-frontend.forwarded-url.acknowledge' />
                </Button>
            }
        />
    );
};
